import { useTranslation } from 'react-i18next';
import { routes } from '../config';

export class NotFoundError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NotFoundError';
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export function NotFoundMessage() {
  const { t } = useTranslation();
  return (
    <div className="error-page">
      <h2>{t('error sorry message')}</h2>
      <div className="error-sub-message">{t('asset not found')}</div>
      <div className="save-links">
        <div>{t('error does it work here')}</div>
        <a href="/">{t('home')}</a>&nbsp;|&nbsp;
        <a href={routes.pvr.base}>{t('recordings')}</a>&nbsp;|&nbsp;
        <a href={routes.tv.base}>{t('watch live tv')}</a>&nbsp;|&nbsp;
        <a href={routes.vod.base}>{t('movies and series')}</a>
      </div>
    </div>
  );
}
